// @flow
import styled from "styled-components";

export const Entry = styled.div`
    width: 100%;
    background-color: #fff;
    position: relative;
`;

export const Title = styled.div`
    background-size: cover;
    background-position: center 32%;
    background-repeat: no-repeat;
    width: 100%;
    height: 20vw;
    min-height: 250px;
    position: relative;
    cursor: pointer;
`;

export const ColorTitle = styled.div`
    width: 100%;
    height: 10vw;
    min-height: 150px;
    position: relative;
    cursor: pointer;
`;

export const TripText = styled.div`
    font-size: 13px;
`;

export const Overlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    padding-top: 25px;
    width: 100%;
`;

export const TitleText = styled.div`
    color: #fff;
    bottom: 0;
    text-align: left;
    padding: 25px;
    font-size: 25px;
    font-weight: bold;
    background: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0, 0.2) 30px);
`;

export const ColorTitleText = styled.div`
    color: #fff;
    bottom: 0;
    text-align: left;
    padding: 25px;
    font-size: 25px;
    font-weight: bold;
`;

export const DescriptionShort = styled.div`
    margin: 16px;
    text-align: left;
    max-height: 113px;
    overflow: hidden;
    cursor: pointer;
`;

export const DescriptionFull = styled.div`
    margin: 16px;
    text-align: left;
    overflow: hidden;
    cursor: pointer;
`;

export const EmptyBlog = styled.div`
    opacity: 0.3;
`;

export const Footer = styled.div`
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0;
    text-align: left;
    position: relative;
    padding-bottom: 16px;
`;

export const DataCell = styled.div`
    display: inline-block;
    vertical-align: top;
    height: 24px;
    line-height: 24px;
    padding-left: 16px;
    padding-top: 16px;
`;

export const DataCellText = styled.div`
    display: inline-block;
    vertical-align: top;
    padding-left: 4px;
`;

export const Actions = styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
    height: 24px;
`;

export const Action = styled.div`
    display: inline-block;
    padding-left: 4px;
`;

export const ActionText = styled.div`
    display: inline-block;
    line-height: 24px;
    vertical-align: top;
    padding: 0 10px 0 5px;
    font-size: small;
`;

export const Icon = styled.div`
    color: #ccc;
    display: inline-block;
`;

export const ClickableIcon = styled.div`
    color: #ccc;
    display: inline-block;
    cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/blog-card/styled.js